import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  buttonSubmit: {
    color: 'white',
    backgroundColor: '#2D93D3',
    marginBottom: 10,
    "&:hover": {
      backgroundColor: "#1e88ca",
    },
  },
  clear: {
    color: 'white',
    backgroundColor: "#ff418a",
    "&:hover": {
      backgroundColor: "#f13a62",
    },
  },
}));